import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Input, Tooltip, Icon, Spin, notification } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { pending } from 'redux-saga-thunk';
import { compose } from 'redux';
import {
  resourceCreateRequest,
  resourceDeleteRequest,
  resourceListReadRequest,
} from '../../../store/resource/actions';
import { fromResource } from '../../../store/selectors';

class Taggable extends React.Component {
  propTypes = {
    remove: PropTypes.func.isRequired,
    getAll: PropTypes.func.isRequired,
    add: PropTypes.func.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string),
  };

  defaultProps = {
    tags: [],
  };

  state = {
    inputVisible: false,
    inputValue: '',
  };

  componentDidMount() {
    const { getAll } = this.props;
    getAll().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : `Could not get list of TTD ids.`,
        duration: 0,
      })
    );
  }

  handleClose = (removedTag, event) => {
    // Handle removing tags manually via dispatch & redux store
    event.preventDefault();

    const { remove } = this.props;
    remove(removedTag).catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : `Could not remove ${removedTag}.`,
        duration: 0,
      });
    });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { tags, add } = this.props;
    const { inputValue } = this.state;

    if (inputValue && tags.indexOf(inputValue) === -1) {
      add(inputValue)
        .then(() =>
          this.setState({
            inputVisible: false,
            inputValue: '',
          })
        )
        .catch(e => {
          this.setState({
            inputVisible: false,
            inputValue: '',
          });
          notification.error({
            message: 'Error',
            description: typeof e === 'string' ? e : `Could not add ${inputValue}.`,
            duration: 0,
          });
        });
    }
  };

  saveInputRef = input => (this.input = input);

  render() {
    const { inputVisible, inputValue } = this.state;
    const { tags, loading } = this.props;
    return (
      <Spin spinning={loading}>
        {tags.map((tag, index) => {
          const isLongTag = tag.length > 20;
          const tagElem = (
            <Tag key={tag} closable onClose={e => this.handleClose(tag, e)}>
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
        {inputVisible && (
          <Input
            ref={this.saveInputRef}
            type="text"
            size="small"
            style={{ width: 78 }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
        )}
        {!inputVisible && (
          <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
            <Icon type="plus" /> Add Campaign ID
          </Tag>
        )}
        <Tooltip
          title={
            <span>
              Add Trade Desk Campaign ids to associate inPath ads with this campaign. To find the
              campaign id, click on a campaign to view the details, in the URL you should see a code
              between "Campaigns/Detail/" and "?advertiser", this is your campaign id:{' '}
              <a href="https://desk.thetradedesk.com/Campaigns/Detail/w3b3vd2?advertiser=dkleet8#rtb-ad-groups">
                https://desk.thetradedesk.com/Campaigns/Detail/w3b3vd2?advertiser=dkleet8#rtb-ad-groups
              </a>
            </span>
          }
        >
          <Icon type="question-circle-o" style={{ marginLeft: 5, color: '#08c' }} />
        </Tooltip>
      </Spin>
    );
  }
}

const mapStateToProps = state => ({
  tags: fromResource.getList(state, 'advertiserCampaignTtd') || [],
  loading:
    pending(state, 'advertiserCampaignTtdCreate') ||
    pending(state, 'advertiserCampaignTtdRead') ||
    pending(state, 'advertiserCampaignTtdDelete'),
});

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { campaignId },
    },
  }
) => ({
  remove: id =>
    dispatch(resourceDeleteRequest('advertiser-campaign/:campaignId/ttd/:id', { campaignId, id })),
  add: id =>
    dispatch(resourceCreateRequest('advertiser-campaign/:campaignId/ttd', { campaignId }, id)),
  getAll: () =>
    dispatch(resourceListReadRequest('advertiser-campaign/:id/ttd', {}, { id: campaignId })),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Taggable);
